import React, { Component } from 'react';
import { trans } from '../../../helpers/index';
import config from '../../../baseConfig/index';
import ApiManager from '../../../apiManager/index';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import Modal from '../../Fragments/Modal';
import { withRouter } from 'react-router-dom';
import ErrorModal from '../../Fragments/ErrorModal';

class FixedStep3 extends Component {

    constructor( props ){
        super( props );

        this.state = {
            buttonDisabled: false,
            email: '',
            formResponse: '',
            showErrorModal: false
        };

        this.goToLoginPage = this.goToLoginPage.bind( this );

    }

    goToLoginPage(){
        this.props.setLoginAction( this.state.email );
        this.props.history.push( config.urlPrefix );
    }

    calcStepWidth(){

        return (100 / this.props.mobileConfig.mobileMaxStep) * this.props.mobileConfig.mobileStep

    }

    emailExist( message ){

        return (
            <Modal
                title={trans(this.props.trans, 'auth.register.tel.modal.title')}
                description={message}
                agreeText={trans(this.props.trans, 'auth.register.tel.modal.agree')}
                agreeAction={this.goToLoginPage}
            />
        );

    }

    sendData( event ){

        this.setState({ buttonDisabled: true });

        ApiManager.postRequest({
            email: this.state.email,
            token: this.props.mobileConfig.mobileToken,
            _token: this.props.csrf_token.data
        }, '/register/fix/email/request').then(( resolve ) => {
            this.setState({
                buttonDisabled: false,
                formResponse: resolve.data
            });

            if ( resolve.data.hasOwnProperty('token') ) {
                this.props.updateParentState({
                    mobileStep: 4,
                    mobileToken: resolve.data.token,
                    mobileEmail: this.state.email
                });
            }

        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });
        event.preventDefault();

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.trans, 'error.modal.title' )}
                description={trans( this.props.trans, 'error.modal.description' )}
                action_text={trans( this.props.trans, 'error.modal.action_text' )}
            />
        );

    }

    render () {

        let errorEmailClass = '',
            errorEmailBox = '',
            errorBox = '',
            modal = '';

        if ( this.state.formResponse.status === 'EMAIL_EXISTS' ) {
            modal = this.emailExist(this.state.formResponse.message);
        }

        if ( this.state.formResponse !== '' ) {

            if ( this.state.formResponse.status === 'INVALID_DATA' ) {

                if ( this.state.formResponse.errors.hasOwnProperty('email') ) {
                    errorEmailClass = ' form-error';
                    errorEmailBox = <div className="form-error-text fs11">{this.state.formResponse.errors.email}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('token') ) {
                    errorBox = <FormMiddlewareError message={this.state.formResponse.errors.token} />;
                }

            }

            if ( this.state.formResponse.status === 'ERROR' ) {

                errorBox = <FormMiddlewareError message={this.state.formResponse.message} trans={this.props.trans} />;

            }

        }

        return (
            <div className="form">
                <form action="#" method="post" onSubmit={(event) => this.sendData( event )}>
                    <div className="form__form-box form__form-box--with-space form-box">
                        <div className="form__sub-title db fs11">{this.props.mobileConfig.mobileStep} {trans(this.props.trans, 'auth.register.step.title')} {this.props.mobileConfig.mobileMaxStep}{trans(this.props.trans, 'auth.register.step' + this.props.mobileConfig.mobileMaxStep)}</div>
                        <div className="form__step-out">
                            <div className="form__step" style={{width: this.calcStepWidth() + '%'}}></div>
                        </div>
                    </div>

                    <div className="form__form-box">
                        <label className="form__label db fs11" htmlFor="tel-number">{trans(this.props.trans, 'auth.register.tel.title3')}</label>
                        <div className="form__field-out form__field-out--with-prefix pr">
                            <input
                                className="form__field fs13 disabled"
                                disabled="disabled"
                                id="tel-number"
                                type="text"
                                value={this.props.mobileConfig.mobileMsisdn}
                            />
                        </div>
                    </div>

                    <div className={`form__form-box form__form-box--with-space${errorEmailClass}`}>
                        <label className="form__label form__label--required db fs11" htmlFor="email">{trans(this.props.trans, 'auth.register.tel.email')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="email"
                                type="text"
                                name="email"
                                placeholder={trans(this.props.trans, 'auth.register.tel.email.placeholder')}
                                value={this.state.email}
                                onChange={( event ) => {
                                    this.setState({
                                        email: event.target.value.trim()
                                    });
                                }}
                            />
                        </div>
                        {errorEmailBox}
                    </div>

                    {errorBox}

                    <button
                        className={`form__submit-btn btn btn--yellow fs17${this.state.buttonDisabled ? ' btn--loading' : ''}`}
                        type="submit"
                        disabled={this.state.buttonDisabled}
                    >{trans(this.props.trans, 'auth.register.tel.button.title3')}</button>

                </form>

                {modal}
                {this.errorModal()}

            </div>
        );

    }

}

export default withRouter( FixedStep3 );